var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideBar',{attrs:{"width":_vm.getSideBarWidth()},scopedSlots:_vm._u([{key:"side-bar-activator",fn:function(){return [_c('Activator',{key:`side_bar_activator>`,staticClass:"self-centered cursor-e-resize",nativeOn:{"mousedown":function($event){return _vm.$router.push({
        name: 'ProjectTaktPlan',
        })}}})]},proxy:true},{key:"content",fn:function(){return [_c('WaggonInfo',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('draggable',{key:`workpackages${_vm.twaggon_id}`,staticClass:"display-flex",staticStyle:{"width":"calc(100% - 32px)"},attrs:{"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.waggon.tworkpackages},on:{"end":function($event){($event.newIndex - $event.oldIndex !== 0)?_vm.requestSnackbarUpdatePosition({
            url: [
              {projects: _vm.project_id},
              {trains: _vm.train_id},
              {taktareas: _vm.taktarea_id},
              {twaggons: _vm.twaggon_id},
              {tworkpackages: _vm.waggon.tworkpackages[$event.oldIndex]}
            ],
            update: {
              position: $event.newIndex - $event.oldIndex
            }
          }).then((payload) => {
            _vm.updateUObjectPosition(payload)
          }):''}}},_vm._l((_vm.getUObjects({type: 'tworkpackages', ids: _vm.waggon.tworkpackages})),function(workpackage,index){return _c('WaggonInfoHeader',{key:'header' + workpackage.id,attrs:{"width":_vm.getHeaderWidth(workpackage.id),"textcolor":workpackage.textcolor,"color":workpackage.color,"text":workpackage.token,"wp_part":workpackage.workpackage_part,"icon":workpackage.icon,"cursor":"grab"},nativeOn:{"click":function($event){_vm.$router.push({
            name: !_vm.$route.name.includes('TaktPlanAddWorkPackage')?_vm.$route.name:'TaktPlanWorkPackageInfo',
            params: {
              tworkpackage_id: workpackage.id,
              }
            })}}},[_c('v-btn',{attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.getNestedWorkPackageCopy(workpackage.id).then(work_package => {
              _vm.updateWBLObject({
              path: [
              {workpackage: ''}
              ],
              update: work_package
              }),
              _vm.$router.push({
                name: 'TaktPlanWorkPackageCopy',
                params: {
                  editor_work_package_id: 'create',
                }
              })
            })}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("content_copy")])],1),_c('StandardDeleteButton',{attrs:{"zoom":1},on:{"clickDelete":function($event){_vm.requestSnackbarDelete({
              url: [
                {projects: _vm.project_id},
                {trains: _vm.train_id},
                {taktareas: _vm.taktarea_id},
                {twaggons: _vm.twaggon_id},
                {tworkpackages: workpackage.id}
              ],
            }).then((payload) => {
              _vm.waggon.tworkpackages.length > 1?
              _vm.$router.push({
                name: 'TaktPlanWorkPackageEdit',
                params: {
                  tworkpackage_id: index === _vm.waggon.tworkpackages.length-1?_vm.waggon.tworkpackages[index-1]:_vm.waggon.tworkpackages[index+1],
                }
                })
                :
                _vm.$router.push({
                  name: 'TaktPlanAddWorkPackage',
                }),
              _vm.deleteUObject(payload)
            })}}})],1)}),1),_c('WaggonInfoHeaderAdd',{nativeOn:{"click":function($event){return _vm.$router.push({
            name: 'TaktPlanAddWorkPackage'
            })}}})]},proxy:true},{key:"body",fn:function(){return [_c('router-view')]},proxy:true}])})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }